import classNames from 'classnames/bind';
import { useLocation, useNavigate } from 'react-router-dom';
import { WEB_VIEW_PARAM } from '../../constants';
import { getMainSiteUrl } from '../../helpers/getMainSiteUrl';
import { useSessionToggle } from '../../hooks/useSessionToggle';
import { login, notFound } from '../../routes';
import text from '../../text';
import Back from '../Icons/Back';
import Close from '../Icons/Close';
import style from './Header.module.scss';

import RILogo from '../Icons/RILogo';

const cx = classNames.bind(style);
const mainSiteUrl = getMainSiteUrl();
const { header } = text;

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isWebview = useSessionToggle(WEB_VIEW_PARAM);

  const onNotFoundPage = location.pathname === notFound.path;
  const onHomePage = location.pathname === login.path;

  return (
    <nav className={cx('login-header')} data-testid="login-header">
      {onHomePage || onNotFoundPage ? (
        <div className={cx('icon-wrapper', 'spacer')}></div>
      ) : (
        // <div className={cx('icon-wrapper')}>
        <button
          type="button"
          id="back-button"
          className={cx('back-icon')}
          onClick={() => navigate(-1)}
          aria-label="Return to previous page"
        >
          <Back />
          <span className={cx('icon-text')}>{header.back}</span>
        </button>
        // </div>
      )}

      {mainSiteUrl ? (
        <a
          href={mainSiteUrl}
          aria-label="River Island"
          data-item-name="logo"
          data-item-category="Navigation"
          className={cx('ri-logo-link')}
        >
          <RILogo className={cx('ri-logo')} />
        </a>
      ) : (
        <RILogo />
      )}

      {onHomePage && !isWebview ? (
        <div className={cx('icon-wrapper')} data-testid="close-icon">
          <button
            type="button"
            id="close-button"
            className={cx('close-icon')}
            aria-label="Go to River Island homepage"
            onClick={() => {
              window.location.href = mainSiteUrl || '/login';
            }}
          >
            <Close />
            <span className={cx('icon-text')}>{header.exit}</span>
          </button>
        </div>
      ) : (
        <div className={cx('icon-pper', 'spacer')}></div>
      )}
    </nav>
  );
};

export default Header;
